export default {
  title: 'Sæt tilgængelighed på pause',
  description: 'Fuldt booket?',
  pause_availabilities: {
    pause_until_end_of_day: 'Sæt reservationer på pause indtil udgangen af dagen?',
    pause_specific_time: 'Sæt reservationer på pause for en anden dag og/eller tid',
  },
  pause_reservations_today: 'Sæt reservationer på pause i dag',
  pause_reservations_another_day: 'Sæt reservationer på pause for en anden dag',
  paused_availabilities_form: {
    date_time: {
      label: 'Vælg en dato og et tidspunkt',
    },
    reason: {
      label: 'Tilføj en årsag (valgfrit)',
      placeholder: 'Indtast beskrivelse...',
    },
  },
  buttons: {
    save: 'Gem',
  },
  error_messages: {
    creation_failed: 'Undtagelsen kunne ikke oprettes',
  },
};
